export default __webpack_public_path__ + "static/media/crest-large.11be3cdd.png";